import { initReactI18next } from 'react-i18next'
import { createI18n } from '@k1p4/i18n'
import type { AppLanguage } from '@k1p4/i18n'

export const LANG_STORAGE_KEY = 'k1p4.lang'

const SUPPORTED: readonly AppLanguage[] = ['pl', 'en']

function isSupported(value: string | null): value is AppLanguage {
  return value !== null && (SUPPORTED as readonly string[]).includes(value)
}

/** Zapamiętany wybór użytkownika; domyślnie polski (PLAN §8.4). */
export function readStoredLanguage(): AppLanguage {
  try {
    const stored = globalThis.localStorage?.getItem(LANG_STORAGE_KEY) ?? null
    return isSupported(stored) ? stored : 'pl'
  } catch {
    return 'pl'
  }
}

/** Czy urządzenie ma zapisany wybór — bez niego przyjmujemy język konta. */
export function hasStoredLanguage(): boolean {
  try {
    return isSupported(globalThis.localStorage?.getItem(LANG_STORAGE_KEY) ?? null)
  } catch {
    return false
  }
}

export function storeLanguage(lang: AppLanguage): void {
  try {
    globalThis.localStorage?.setItem(LANG_STORAGE_KEY, lang)
  } catch {
    /* prywatny tryb przeglądarki — wybór działa tylko w tej sesji */
  }
}

export const { i18n, ready: i18nReady } = createI18n({
  lng: readStoredLanguage(),
  modules: [initReactI18next],
})
